


















import {Component, Vue} from "vue-property-decorator";

interface Link {
    i18nKey: string;
    path: string;
}

@Component
export default class Navigation extends Vue {

    public leftLinks: Link[] = [
        {i18nKey: "navigation.lessonsLabel", path: "/lessons"}
    ];
    public rightLinks: Link[] = [
        {i18nKey: "navigation.aboutLabel", path: "/about"}
    ];

    public gotoRoute(link: Link) {
        this.$router.push(link.path);
    }

}
